const isTablet = (width: number) => {
    return width <= 1024 ? true : false;
};

export { isTablet };
